var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('page-section', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "titWrapAlign": "text-center"
    }
  }, [_c('template', {
    slot: "tit"
  }, [_vm._v("아이디 찾기")]), _c('div', {
    staticClass: "mw-588px mx-auto"
  }, [_c('v-row', {
    staticClass: "row--xs"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-phone-field', _vm._b({
    attrs: {
      "dense": false
    },
    model: {
      value: _vm.phone,
      callback: function ($$v) {
        _vm.phone = $$v;
      },
      expression: "phone"
    }
  }, 'v-phone-field', Object.assign({}, _vm.attrs_input, {
    loading: _vm.loading
  }), false), [[_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "w-100 w-sm-80px",
    attrs: {
      "x-large": "",
      "color": "grey"
    },
    on: {
      "click": _vm.certify
    }
  }, 'v-btn', Object.assign({}, _vm.btn_primar, {
    btnAttrs: {},
    dense: true
  }), false), [_vm._v("본인인증")])], 1)]], 2)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "dense": false,
      "type": "number",
      "placeholder": "인증번호를 입력하세요."
    },
    model: {
      value: _vm.otp,
      callback: function ($$v) {
        _vm.otp = $$v;
      },
      expression: "otp"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs_input, {
    loading: _vm.loading
  }), false))], 1)], 1), _c('div', {
    staticClass: "btn-wrap btn-wrap--sm"
  }, [_c('v-row', {
    staticClass: "row--sm"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', _vm._b({
    attrs: {
      "x-large": "",
      "block": ""
    },
    on: {
      "click": _vm.recovery
    }
  }, 'v-btn', Object.assign({}, _vm.btn_primary, {
    loading: _vm.loading
  }), false), [_vm._v("아이디 찾기")])], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('u-divider-group', {
    staticClass: "divider-group--dark text-center"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("로그인")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/login/find-password/"
    }
  }, [_vm._v("비밀번호 찾기")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/join"
    }
  }, [_vm._v("회원가입")])], 1)])], 1)], 1)], 1)], 1)], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }